    import fileModel from '@/shared/file/file-model';

export default {
  default() {
    return {
      id: null,
      name: '',
      attachments: []
    }
  },

  forSimple(data) {
    return {
      id: data.id,
      attachments: fileModel.toDatabase(data.attachments),

      name: data.name  ? data.name : '',
    }
  },

  forCreate(data) {
    return {
      ...data,
      // pictures: fileModel.toDatabase(data.pictures),
      attachments: fileModel.toDatabase(data.attachments)
    };
  },

  forUpdate(data) {
    return {
      ...data,
      // pictures: fileModel.toDatabase(data.pictures),
      attachments: fileModel.toDatabase(data.attachments),
    };
  }
};



// WEBPACK FOOTER //
// ./src/entities/document/document-model.js